import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const QuickAdmin = () => {
  const [email, setEmail] = useState('andrebravodj@gmail.com');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const makeAdmin = async () => {
    try {
      const response = await fetch(`https://cosmobeauty.no/api/setup-admin?secret=cosmobeauty2025`);
      const data = await response.json();
      setMessage(data.message);
    } catch (error) {
      setMessage('Error: ' + error.message);
    }
  };

  const createAdminUser = async () => {
    try {
      const response = await fetch(`https://cosmobeauty.no/api/create-admin-user?secret=cosmobeauty2025`);
      const data = await response.json();
      setMessage(`✅ ${data.message}\n\nLogin Info:\nEmail: ${data.email}\nPassword: ${data.password}`);
    } catch (error) {
      setMessage('Error: ' + error.message);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] pt-32 pb-24">
      <div className="max-w-md mx-auto px-6">
        <h1 className="text-3xl font-sans mb-8 text-center">Quick Admin Setup</h1>
        
        <div className="bg-white p-8 rounded-lg shadow-md space-y-4">
          <div>
            <label className="block text-sm mb-2">Email:</label>
            <input 
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border px-4 py-2"
            />
          </div>

          <button
            onClick={makeAdmin}
            className="w-full bg-blue-600 text-white px-6 py-3 hover:bg-blue-700"
          >
            1. Make Admin
          </button>

          <button
            onClick={createAdminUser}
            className="w-full bg-green-600 text-white px-6 py-3 hover:bg-green-700"
          >
            2. Create Admin User (admin@cosmobeauty.no)
          </button>

          <button
            onClick={() => navigate('/login')}
            className="w-full bg-purple-600 text-white px-6 py-3 hover:bg-purple-700"
          >
            3. Go to Login
          </button>

          {message && (
            <div className="mt-4 p-4 bg-gray-100 rounded">
              <p className="text-sm">{message}</p>
            </div>
          )}

          <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded">
            <p className="text-xs"><strong>Instructions:</strong></p>
            <ol className="text-xs list-decimal ml-4 mt-2 space-y-1">
              <li>Click "Create Admin User"</li>
              <li>Copy the email and password from the message</li>
              <li>Click "Go to Login"</li>
              <li>Login with the credentials shown above</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickAdmin;
